import React from 'react';
import moment from 'moment-timezone';
import Text from 'components/Text';
import MediaObject from 'components/MediaObject';

export type CoachingSessionHeaderProps = {
  date: string;
  numberOfSessions: number;
};

export default function CoachingSessionsHeader(props: CoachingSessionHeaderProps) {
  const { date, numberOfSessions } = props;
  const headerDateFormat = 'ddd, MMM D';
  return (
    <MediaObject baseline figure="left" gutter="small">
      <Text data-test="coaching-schedule-header-date-string" weight="semibold" size="xsmall">
        {moment(date)
          .format(headerDateFormat)
          .toString()}
      </Text>
      <Text size="small" color="graphite">
        <MediaObject figure="left" gutter="small">
          <Text weight="semibold" size="xsmall">
            |
          </Text>
          <Text data-test="coaching-schedule-header-number-sessions" size="xsmall">
            {numberOfSessions > 0 ? numberOfSessions : 'No'} sessions
          </Text>
        </MediaObject>
      </Text>
    </MediaObject>
  );
}
